// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2exF_","addWidgetButton":"Header_addWidgetButton__1r93Z","dashboardTabs":"Header_dashboardTabs__3If-s","active":"Header_active__1TEzy"};